import { ArrayUtils } from "../utilities/arrays";
import moment from "moment";
export var DateExpressions = [{
        key: "Today",
        expression: function (data) { return new Date(); },
        unit: 'd'
    },
    {
        key: "Now",
        expression: function (data) { return new Date(); },
        unit: 'm'
    },
    {
        key: "Yesterday",
        expression: function (data) { return moment().subtract(1, "days").toDate(); },
        unit: 'd'
    },
    {
        key: "Week",
        expression: function (data) { return moment().startOf('isoWeek').toDate(); },
        unit: 'w',
        unitText: "isoWeek"
    },
    {
        key: "Month",
        expression: function (data) { return moment().startOf('month').toDate(); },
        unit: 'M',
        unitText: "month"
    },
    {
        key: "Quarter",
        expression: function (data) { return moment().startOf('quarter').toDate(); },
        unit: 'Q',
        unitText: "quarter"
    },
    {
        key: "Year",
        expression: function (data) { return moment().startOf('year').toDate(); },
        unit: 'y',
        unitText: "year"
    }
];
var DateExpressionParser = /** @class */ (function () {
    function DateExpressionParser() {
    }
    DateExpressionParser.isValidExpression = function (expression) {
        return DateExpressionParser.parseDateInterceptor(expression, null, function (parsed, index, isPlus, constantNumber) { return parsed; });
    };
    DateExpressionParser.getDateValue = function (expression, data) {
        return DateExpressionParser.parseDateInterceptor(expression, null, function (parsed, index, isPlus, constantNumber) {
            if (parsed && !constantNumber) {
                return DateExpressions[index].expression(data);
            }
            else if (parsed && constantNumber) {
                var date = DateExpressions[index].expression(data);
                if (isPlus) {
                    date = new Date(moment(date).add(Number(constantNumber), DateExpressions[index].unit).valueOf());
                }
                else {
                    date = new Date(moment(date).subtract(Number(constantNumber), DateExpressions[index].unit).valueOf());
                }
                return date;
            }
            else {
                return undefined;
            }
        });
    };
    DateExpressionParser.parseDateInterceptor = function (expression, data, onReturn) {
        if (data === void 0) { data = null; }
        if (!expression) {
            return false;
        }
        var expStr = expression.toString().replace(/ /g, '').toLowerCase();
        var index = ArrayUtils.findIndex(DateExpressions, function (x) { return expStr.indexOf(x.key.toLocaleLowerCase()) > -1; });
        if (index > -1) {
            var key = DateExpressions[index].key.trim().toLocaleLowerCase();
            var indexKey = expStr.indexOf(key);
            expStr = expStr.substr(indexKey + key.length);
            if (expStr.length > 0 && (expStr[0] == '+' || expStr[0] == '-')) {
                var constantNumber = expStr.substr(1);
                if (DateExpressionParser.isInt(constantNumber)) {
                    return onReturn(true, index, expStr[0] == '+', Number(constantNumber));
                }
                else {
                    return onReturn(false, -1, false, null);
                }
            }
            else {
                return onReturn(true, index, expStr[0] == '+', 0);
            }
        }
        return onReturn(false, -1, false, null);
    };
    DateExpressionParser.isInt = function (value) {
        return !isNaN(value) &&
            parseInt(Number(value).toString()) == value &&
            !isNaN(parseInt(value, 10));
    };
    DateExpressionParser.isDateExpression = function (expression) {
        if (!expression) {
            return false;
        }
        var expStr = expression.toString().replace(/ /g, '').toLowerCase();
        var index = ArrayUtils.findIndex(DateExpressions, function (x) { return expStr.indexOf(x.key.toLocaleLowerCase()) > -1; });
        if (index > -1) {
            return true;
        }
        return false;
    };
    DateExpressionParser.isExpressionDateRange = function (expression) {
        if (!expression) {
            return false;
        }
        var expStr = expression.toString().replace(/ /g, '').toLowerCase();
        var index = ArrayUtils.findIndex(DateExpressions, function (x) { return expStr.indexOf(x.key.toLocaleLowerCase()) > -1; });
        if (index > -1) {
            return DateExpressions[index].unit == 'w' || DateExpressions[index].unit == 'M' || DateExpressions[index].unit == 'Q' || DateExpressions[index].unit == 'y';
        }
        return false;
    };
    DateExpressionParser.getEndDateFromRangeExpression = function (expression, date) {
        if (!expression || !DateExpressionParser.isExpressionDateRange(expression)) {
            return null;
        }
        var expStr = expression.toString().replace(/ /g, '').toLowerCase();
        var index = ArrayUtils.findIndex(DateExpressions, function (x) { return expStr.indexOf(x.key.toLocaleLowerCase()) > -1; });
        if (index > -1) {
            if (DateExpressions[index].unitText && DateExpressions[index].unitText != null) {
                return moment(date).endOf(DateExpressions[index].unitText);
            }
        }
        return null;
    };
    return DateExpressionParser;
}());
export { DateExpressionParser };
